import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './css/index.css';
import './css/globals.css';

import DataContext from './context/Datacontext';
import { App } from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <DataContext>
            <App />
        </DataContext>
    </BrowserRouter>
);

